export const ganzimmunColors = {
  black: '#000000',
  darkBlue: '#0053a1',
  blue: '#7ab2e1',
  lightBlue: '#c1d8f2',
  aquamarine: '#0096ae',
  magenta: '#e62154',
  purple: '#96368b',
  orange: '#f28e77'
} as const

export const primaryColorShades = {
  50: '#f8fbfe',
  100: '#f0f6fc',
  200: '#e2eef9',
  300: '#d2e4f6',
  400: '#c9def4',
  500: ganzimmunColors.lightBlue,
  600: '#a8c7e9',
  700: '#8fb6df',
  800: '#70a1d2',
  900: '#4e86bd',
  950: '#315f90'
} as const

export const surfaceColorShades = {
  0: '#ffffff',
  50: '#f8fbfe',
  100: '#eef5fb',
  200: '#dceaf7',
  300: ganzimmunColors.lightBlue,
  400: '#a3c7e9',
  500: ganzimmunColors.blue,
  600: '#578cba',
  700: '#3d698f',
  800: '#254966',
  900: '#132d43',
  950: '#081923'
} as const
